/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateProjectStageStatusCommand } from '../../models/update-project-stage-status-command';
import { UpdateProjectStageStatusCommandResult } from '../../models/update-project-stage-status-command-result';

export interface ApiProjectStagesUpdateProjectStageStatusPatch$Params {
      body?: UpdateProjectStageStatusCommand
}

export function apiProjectStagesUpdateProjectStageStatusPatch(http: HttpClient, rootUrl: string, params?: ApiProjectStagesUpdateProjectStageStatusPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectStageStatusCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectStagesUpdateProjectStageStatusPatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateProjectStageStatusCommandResult>;
    })
  );
}

apiProjectStagesUpdateProjectStageStatusPatch.PATH = '/api/ProjectStages/UpdateProjectStageStatus';
